import { render } from "./Human.vue?vue&type=template&id=108ffb1a"
const script = {}
script.render = render

export default script